import React from 'react'
import PropTypes from 'prop-types'
import { MyTimesheet } from './my-timesheet'
import { TimesheetByProjects } from './timesheet-by-projects'
import { TimesheetApproval } from './timesheet-approval'
import { TimesheetStatus } from './timesheet-status'

export const Searchbar = (props) => {
  switch (props.activeTab) {
    case 1:
      return <MyTimesheet { ...props } />
    case 2 :
      return <TimesheetByProjects { ...props } />
    case 3:
      return <TimesheetStatus { ...props } />
    case 4:
      return <TimesheetApproval { ...props } />
    default:
      return null
  }
}

Searchbar.propTypes = {
  activeTab: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/timesheet/search-bar/index.js